// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__wscnj","content":"Modal_content__zFIsM"};